import { useState } from "react"
import { Alert } from "@mui/material"

export default function useErrorLocal() {
  const [message, setMessage] = useState(null)
  const [severity, setSeverity] = useState("error")

  const error = (msg) => {
    setSeverity("error")
    setMessage(msg)
    autoClear()
  }

  const success = (msg) => {
    setSeverity("success")
    setMessage(msg)
    autoClear()
  }

  const info = (msg) => {
    setSeverity("info")
    setMessage(msg)
    autoClear()
  }

  const autoClear = () => {
    setTimeout(() => {
      setMessage(null)
    }, 5000)
  }

  // to mimic <AlertError /> pattern:
  const Error = () =>
    message ? (
      <Alert severity={severity} sx={{ mt: 2 }}>
        {message}
      </Alert>
    ) : null

  return { error, success, info, Error }
}
